import { render, staticRenderFns } from "./AddGoal.vue?vue&type=template&id=663f539f&"
import script from "./AddGoal.vue?vue&type=script&lang=js&"
export * from "./AddGoal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports